export const partnersEs = {
  discardTitle: '¿Descartar los cambios sin guardar?',
  discardDescription:
    'Los cambios no se han guardado. Continúe editando o descártelos expresamente.',
  keepEditing: 'Seguir editando',
  discard: 'Descartar',

  all: {
    title: 'Todos los contactos',
    subtitle: 'Descripción completa de todos los socios comerciales y sus roles.',
  },
  customers: {
    title: 'Clientes',
    subtitle: 'Cuentas por cobrar, condiciones y ingresos de todos los clientes activos.',
  },
  prospects: {
    title: 'Prospectos / oportunidades',
    subtitle: 'Canal de ventas desde el primer contacto hasta el cierre.',
  },
  suppliers: {
    title: 'Proveedores',
    subtitle: 'Cuentas por pagar, calificaciones y condiciones de compra.',
  },
  searchPlaceholder: 'Buscar por nombre, número, ciudad, ID de IVA, cuenta …',
  searchLabel: 'Buscar socios comerciales',
  columnsMenu: 'Columnas',
  createTitle: 'Nuevo socio comercial',
  editTitle: 'Editar socio comercial',
  formDescription:
    'Los roles controlan qué campos aparecen. El número de socio se asigna automáticamente si se deja vacío.',
  created: 'Socio comercial creado.',
  updated: 'Socio comercial guardado.',
  saveError: 'No se pudo guardar el socio comercial.',
  validationTitle: 'Revise los datos',
  validationSummary: 'Revise los datos marcados. Sus entradas se han conservado.',
  quick: {
    title: 'Creación rápida',
    description: 'Bastan un rol y un nombre. El resto de datos puede añadirse después.',
    completeTitle: 'Creación completa',
    completeDescription: 'Edite todos los datos maestros y condiciones disponibles.',
    showAll: 'Mostrar todos los campos',
    showQuick: 'Volver a creación rápida',
    defaultsUnavailable:
      'Los valores predeterminados del tenant no están disponibles temporalmente. Se muestran valores seguros.',
    step1: '1. Cliente o empresa',
    step2: '2. Dirección (opcional)',
    step3: '3. Contacto (opcional)',
    step4: '4. Facturación e impuestos (opcional)',
    completionHint:
      'Puede completar la ficha después de guardar. Antes de contabilizar, el documento muestra una lista de los datos empresariales que faltan.',
  },
  roles: {
    customer: 'Cliente',
    prospect: 'Prospecto',
    supplier: 'Proveedor',
  },
  actions: {
    create: 'Nuevo socio',
    createCustomer: 'Nuevo cliente',
    createProspect: 'Nuevo prospecto',
    createSupplier: 'Nuevo proveedor',
    export: 'Exportar',
    call: 'Llamada',
    email: 'Correo electrónico',
    logCall: 'Registrar llamada',
    createQuote: 'Crear documento',
    convert: 'Convertir a cliente',
    backToList: 'Volver al resumen',
  },
  tabs: {
    master: 'Datos maestros y direcciones',
    sales: 'Ingresos y documentos',
    purchasing: 'Compras y artículos',
    orders: 'Órdenes de compra',
    insurance: 'Límite de crédito y seguro',
    customFields: 'Campos personalizados',
    history: 'Historial',
    questionnaires: 'Cuestionarios',
    telephony: 'Telefonía e historial',
    whatsapp: 'WhatsApp',
  },
  sections: {
    roles: 'Roles',
    rolesHint:
      'Un socio puede ser cliente, prospecto y proveedor al mismo tiempo. Se requiere al menos un rol.',
    masterData: 'Datos maestros',
    address: 'Dirección',
    tax: 'Impuestos e identificación',
    customerConditions: 'Condiciones del cliente',
    prospect: 'Prospecto y proyecto de ventas',
    supplier: 'Datos del proveedor',
    customFields: 'Campos personalizados',
    customFieldsHint:
      'Los campos con un prefijo de grupo (cliente:, prospecto:, proveedor:) solo aparecen para el rol correspondiente.',
  },
  detail: {
    since: 'Creado el {{date}}',
  },
  values: {
    days_one: '{{count}} día',
    days_other: '{{count}} días',
  },
  columns: {
    partnerNumber: 'Número',
    displayName: 'Nombre',
    roles: 'Roles',
    status: 'Estado',
    industry: 'Industria',
    industryCode: 'Código de sector',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    city: 'Ciudad',
    countryCode: 'País',
    tags: 'Etiquetas',
    debtorAccountNumber: 'Deudor',
    paymentTermsDays: 'Condiciones de pago',
    creditLimit: 'Límite de crédito',
    leadStatus: 'Etapa',
    leadSource: 'Fuente',
    leadScore: 'Puntuación',
    dealSizeEstimated: 'Potencial',
    winProbability: 'Probabilidad',
    expectedClosingDate: 'Cierre esperado',
    creditorAccountNumber: 'Acreedor',
    supplierRating: 'Calificación',
    minimumOrderValue: 'Valor mínimo de pedido',
    deliveryTimeDays: 'Plazo de entrega',
    riskStatus: 'Riesgo',
  },
  fields: {
    type: 'Tipo de socio',
    status: 'Estado',
    partnerNumber: 'Número de socio',
    partnerNumberHint: 'Dejar vacío para asignación automática (KD-, INT-, LF-).',
    industry: 'Industria',
    industryCode: 'Código de sector',
    industryCodeHint:
      'Opcional: WZ 2025 para Alemania, NAF/APE para Francia. Busque por código o denominación oficial; la selección rellena automáticamente el sector.',
    industryCodeSearchHint:
      '{{count}} códigos disponibles. Introduzca un código o término para acotar la selección.',
    industryCodeInvalid: 'Introduzca un texto de un máximo de {{max}} caracteres.',
    companyName: 'Nombre de la empresa',
    tradingName: 'Nombre comercial',
    legalForm: 'Forma legal',
    department: 'Departamento',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    mobile: 'Móvil',
    website: 'ID de IVA',
    street: 'Calle',
    houseNumber: 'Número de casa',
    addressLine2: 'Dirección 2',
    postalCode: 'Ciudad',
    city: 'Ciudad',
    region: 'Región',
    countryCode: 'País',
    vatId: 'ID de IVA',
    vatIdStatus: 'Estado de NIF',
    taxNumber: 'Registro comercial',
    siren: 'SIREN',
    siret: 'SIRET',
    taxCategory: 'Estrategia de impuesto sobre ventas',
    gln: 'GLN',
    eoriNumber: 'Número de identificación fiscal EORI',
    preferredLanguage: 'Idioma preferido de los documentos',
    preferredLanguageHint:
      'Se utiliza en nuevos documentos, el portal y los correos dirigidos al cliente.',
    currency: 'Moneda',
    ownerName: 'Gerente de cuenta',
    tags: 'Etiquetas',
    tagsHint: 'Separe múltiples valores con comas.',
    debtorAccountNumber: 'Cuenta de deudor DATEV',
    debtorAccountHint: 'Rango válido: 10000–69999.',
    creditLimit: 'Límite de crédito',
    creditRating: 'Calificación crediticia',
    creditRatingHint: 'Escala de Creditreform 100–600; menor es mejor.',
    priceGroup: 'Grupo de precios',
    defaultDiscountPct: 'Descuento',
    paymentTerms: 'Condiciones de pago',
    paymentTermsDays: 'Términos de pago (días)',
    discountPercent: 'Descuento en efectivo',
    discountDays: 'Período de descuento en efectivo (días)',
    deliveryTerms: 'Términos de entrega',
    minRemainingShelfLifeDays: 'Vida útil mínima restante (días)',
    deliveryBlock: 'Bloqueo de entrega',
    dunningBlock: 'Bloqueo de recordatorio de pago',
    leadStatus: 'Etapa del pipeline',
    leadSource: 'Fuente',
    leadScore: 'Puntuación de lead (0–100)',
    dealSizeEstimated: 'Tamaño estimado del trato',
    winProbability: 'Probabilidad de ganar (%)',
    expectedClosingDate: 'Fecha de cierre esperada',
    lostReason: 'Razón de pérdida',
    convertedAt: 'Convertido el',
    creditorAccountNumber: 'Cuenta de acreedor DATEV',
    creditorAccountHint: 'Rango válido: 70000–99999.',
    supplierRating: 'Calificación del proveedor',
    minimumOrderValue: 'Valor mínimo de pedido',
    deliveryTimeDays: 'Plazo estándar (días)',
    incoterms: 'Incoterms',
    supplierIban: 'IBAN',
    supplierBic: 'BIC',
    supplierBankName: 'Banco',
  },
  types: {
    COMPANY: 'Empresa',
    PERSON: 'Individual',
  },
  statuses: {
    ACTIVE: 'Activo',
    PROSPECT: 'Prospecto',
    BLOCKED: 'Bloqueado',
    INACTIVE: 'Inactivo',
  },
  vatIdStatuses: {
    UNCHECKED: 'Sin comprobar',
    VALID: 'Válido',
    INVALID: 'Inválido',
    NOT_CHECKABLE: 'No comprobable',
    SERVICE_UNAVAILABLE: 'Servicio no disponible',
  },
  taxCategories: {
    DOMESTIC: 'Regular (doméstico)',
    EU_B2B: 'Intracomunitario (UE B2B)',
    EU_B2C: 'UE B2C',
    THIRD_COUNTRY: 'Exportación (tercer país)',
    REVERSE_CHARGE_DOMESTIC: 'Inversión del sujeto pasivo (doméstico)',
    TAX_EXEMPT: 'Exento de impuestos',
  },
  industries: {
    RETAIL: 'Venta al por menor',
    WHOLESALE: 'Venta al por mayor',
    MANUFACTURING: 'Fabricación',
    GASTRONOMY: 'Gastronomía',
    LOGISTICS: 'Logística',
    HEALTHCARE: 'Salud',
    PUBLIC_SECTOR: 'Sector público',
    CONSTRUCTION: 'Construcción',
    AGRICULTURE: 'Agricultura',
    SERVICES: 'Servicios',
    OTHER: 'Otros',
  },
  leadStatuses: {
    NEW: 'Nuevo',
    CONTACTED: 'Contactado',
    QUALIFIED: 'Calificado',
    PROPOSAL_SENT: 'Propuesta enviada',
    NEGOTIATION: 'Negociación',
    WON: 'Ganado',
    LOST: 'Perdido',
  },
  leadSources: {
    WEBSITE: 'ID de IVA',
    TRADE_FAIR: 'Feria comercial',
    REFERRAL: 'Referido',
    COLD_OUTREACH: 'Contacto en frío',
    INBOUND_CALL: 'Llamada entrante',
    OTHER: 'Otros',
  },
  supplierRatings: {
    A: 'A – muy fiable',
    B: 'B – aceptable',
    C: 'C – crítico',
  },
  riskStatuses: {
    NORMAL: 'Sin novedad',
    WATCHLIST: 'Lista de vigilancia',
    DELIVERY_LOCK: 'Bloqueo de entrega',
    SALES_LOCK: 'Bloqueo de ventas',
    COLLECTION: 'Cobranza / bloqueado',
    INSOLVENCY: 'Insolvencia',
  },
  risk: {
    lockAction: 'Bloquear cliente',
    unlockAction: 'Desbloquear cliente',
    lockTitle: 'Bloquear socio comercial',
    lockDescription:
      'El bloqueo impide inmediatamente cualquier documento para {{name}}. La razón se registra en el registro de auditoría.',
    lockConfirm: 'Aplicar bloqueo',
    lockSuccess: 'El socio comercial está bloqueado.',
    lockError: 'No se pudo aplicar el bloqueo.',
    unlockTitle: 'Liberar bloqueo',
    unlockDescription: 'El bloqueo sobre {{name}} será levantado. Razón anterior: {{reason}}',
    unlockConfirm: 'Liberar bloqueo',
    unlockSuccess: 'El bloqueo ha sido levantado.',
    unlockError: 'No se pudo levantar el bloqueo.',
    reasonRequired: 'Se requiere una razón.',
    fields: {
      riskStatus: 'Clasificación de riesgo',
      followUpStatus: 'Clasificación después de la liberación',
      blockReason: 'Razona por la bloqueada',
      blockReasonHint:
        'Example: “Corte de insolvencia archivo número: IN 412/26” o “Entregado a Creditreform de cobro el 15/08/2026”.',
      unblockReason: 'Razona por la liberación',
      unblockReasonHint: 'Example: “Factura de deudas pagadas en total el 01/09/2026”.',
    },
    banner: {
      blockedTitle: '🚨 Aviso: EL CLIENTE ESTÁ BLOCKEADO (estado: {{status}})',
      warningTitle: 'Clasificación de riesgo: {{status}}',
      reason: 'Razón: {{reason}}',
      since: 'Blockeado el {{date}} por {{user}}',
      consequence:
        'No se pueden crear facturas de entrega ni facturas de cuenta si no se ha pagado con anticipación o en efectivo — solo se puede liberar con pago o efectivo.',
    },
  },
  insurance: {
    policySection: 'Poliza de crédito comercial',
    claimSection: 'Reclamación',
    saved: 'La poliza de crédito comercial ha sido guardada.',
    saveError: 'La poliza de crédito comercial no ha sido guardada.',
    limitExceededHint:
      'El límite máximo asegurado está agotado. No se cubren entregas adicionales.',
    claimIdleHint:
      'La sección de reclamaciones se vuelve relevante una vez que el cliente pasa a cobro o insolvencia.',
    openAmount: 'Cuentas por cobrar abiertas: {{amount}}',
    expectedPayout: 'Indemnización de seguro esperada',
    expectedPayoutHint: 'Monto de la reclamación menos el deducible de {{percent}}.',
    actions: {
      prepareClaim: 'Registrar reclamación',
    },
    statuses: {
      NOT_INSURED: 'No asegurado',
      INSURED: 'Asegurado',
      LIMIT_EXCEEDED: 'Límite excedido',
      CLAIM_REPORTED: 'Reclamación reportada',
      INDEMNIFIED: 'Indemnizado',
    },
    fields: {
      status: 'Estado del seguro',
      company: 'Compañía de seguros',
      companyHint: 'Ejemplo: Allianz Trade / Euler Hermes, Atradius, Coface.',
      policyNumber: 'Póliza / número de límite',
      limit: 'Límite máximo asegurado (€)',
      deductiblePercent: 'Deducible (%)',
      deductibleHint: 'Participación que asume el inquilino en caso de reclamación.',
      claimDate: 'Fecha de reporte de la reclamación',
      claimAmount: 'Importe de la reclamación reportada (€)',
      payoutAmount: 'Importe indemnizado (€)',
    },
  },
  incoterms: {
    EXW: 'Ex works',
    FCA: 'Transporte libre',
    FAS: 'Franco al costado del buque',
    FOB: 'Franco a bordo',
    CFR: 'Costo y flete',
    CIF: 'Costo, seguro y flete',
    CPT: 'Transporte pagado hasta',
    CIP: 'Transporte y seguro pagados hasta',
    DAP: 'Entregado en el lugar',
    DPU: 'Entregado en el lugar descargado',
    DDP: 'Entregado con derechos pagados',
  },
  documentTypes: {
    QUOTE: 'Cotización',
    ORDER: 'Pedido',
    DELIVERY_NOTE: 'Nota de entrega',
    INVOICE: 'Factura',
    CREDIT_NOTE: 'Nota de crédito',
    CANCELLATION: 'Cancelación',
    PURCHASE_ORDER: 'Orden de compra',
  },
  documentStatuses: {
    DRAFT: 'Borrador',
    SENT: 'Enviado',
    ACCEPTED: 'Aceptado',
    REJECTED: 'Rechazado',
    CONFIRMED: 'Confirmado',
    IN_PROGRESS: 'En progreso',
    PARTIALLY_PROCESSED: 'Procesado parcialmente',
    SHIPPED: 'Enviado',
    COMPLETED: 'Completado',
    POSTED: 'Publicado',
    CANCELLED: 'Cancelado',
  },
  filters: {
    status: 'Estado',
    industry: 'Industria',
    industryCode: 'Filtrar código de sector (exacto)',
    tags: 'Etiquetas',
    vatIdStatus: 'ID de IVA',
    riskStatus: 'Riesgo',
    leadStatus: 'Etapa del pipeline',
    leadSource: 'Fuente',
    supplierRating: 'Calificación',
    reset: 'Restablecer filtros',
  },
  states: {
    empty: 'Aún no hay socios comerciales.',
    emptyFiltered: 'Ningún socio comercial coincide con la selección actual.',
    error: 'No se pudo cargar la lista.',
    detailError: 'No se pudo cargar el socio comercial.',
  },
  export: {
    csv: 'Descargar CSV',
    xlsx: 'Descargar Excel',
    success: 'Exportación creada.',
    error: 'Falló la exportación.',
  },
  bulkDelete: {
    selected: 'Seleccionados: {{count}}',
    action: 'Eliminar selección',
    help: 'Ayuda para eliminar varios prospectos',
    deleted: 'Eliminados: {{count}}.',
    failed: 'No eliminados: {{count}}. Estas entradas siguen seleccionadas.',
    hasDocuments: 'Este socio comercial tiene documentos y no se puede eliminar.',
    error: 'No se pudo eliminar la entrada.',
    title: 'Eliminar los prospectos seleccionados',
    description:
      'Los prospectos seleccionados se desactivarán y ocultarán. Se conservan los socios con documentos. La eliminación afecta al socio comercial completo, incluidos sus otros roles.',
    select: 'Seleccionar {{name}}',
    selectPage: 'Seleccionar todos en esta página',
  },
  delete: {
    title: 'Eliminar socio comercial',
    description: 'El socio "{{name}}" se establecerá como inactivo y oculto.',
    success: 'Socio comercial eliminado.',
    error: 'No se pudo eliminar al socio comercial.',
  },
  pipeline: {
    title: 'Canal de ventas',
    viewSwitch: 'Cambiar vista',
    listView: 'Lista',
    boardView: 'Tablero',
    emptyColumn: 'Sin entradas',
    moved: '{{name}} se movió a "{{stage}}".',
    moveError: 'No se pudo cambiar la etapa del canal.',
    movePrevious: 'Mover {{name}} una etapa hacia atrás',
    moveNext: 'Mover {{name}} una etapa hacia adelante',
    lostTitle: 'Marcar prospecto como perdido',
    lostDescription: 'Por favor, proporcione la razón de la pérdida.',
    lostPlaceholder: 'p. ej. precio demasiado alto, se eligió al competidor, proyecto aplazado',
  },
  convert: {
    title: 'Convertir prospecto en cliente',
    description:
      'El registro "{{name}}" se mantiene; se conservan llamadas, notas, cotizaciones y chats.',
    debtorHint: 'Dejar vacío para asignar el siguiente número de deudor DATEV disponible.',
    debtorPlaceholder: 'automático',
    keepProspectRole: 'Mantener también el rol de "prospecto"',
    success: 'Conversión completada. Cuenta del deudor {{number}}.',
    error: 'La conversión falló.',
  },
  sales: {
    title: 'Ingresos y comportamiento de pagos',
    loadError: 'No se pudieron cargar las métricas.',
    revenueYtd: 'Ingresos acumulados del año',
    revenuePreviousYear: 'Ingresos del año anterior',
    revenueChange: 'Cambio respecto al año anterior',
    orderIntake: 'Entrada de pedidos',
    documentCounts: 'Cotizaciones / pedidos / notas de entrega / facturas',
    averageOrderValue: 'Valor promedio del pedido',
    paidAmount: 'Monto pagado',
    credits: 'Créditos y cancelaciones',
    lastDocuments: 'Último pedido / última factura',
    period: 'período',
    periods: {
      currentYear: 'Año actual',
      previousYear: 'Año anterior',
      last12Months: 'Últimos 12 meses',
      all: 'Todo el tiempo',
      custom: 'Rango personalizado',
    },
    from: 'Desde',
    to: 'Hasta',
    searchDocuments: 'Buscar número de documento o referencia …',
    allTypes: 'Todos los tipos de documentos',
    allStatuses: 'Todos los estados',
    allPayments: 'Todos los estados de pago',
    noDocumentPermission: 'Se requiere permiso de documento para ver ingresos y documentos.',
    columns: {
      number: 'Número',
      type: 'Tipo',
      date: 'Fecha',
      status: 'Estado',
      payment: 'Pago',
      net: 'Neto',
      gross: 'Bruto',
      open: 'Abierto',
      due: 'Vencimiento',
      salesRep: 'Representante de ventas',
    },
    revenueTotal: 'Total de ingresos',
    openInvoices_one: 'Factura abierta ({{count}})',
    openInvoices_other: 'Facturas abiertas ({{count}})',
    overdueInvoices_one: 'Factura vencida ({{count}})',
    overdueInvoices_other: 'Facturas vencidas ({{count}})',
    openQuotes: 'Cotizaciones abiertas',
    openOrders: 'Órdenes abiertas',
    averagePaymentTermsDays: 'Plazos de pago promedio',
    lastOrderDate: 'Último pedido',
    documents: 'Documentos',
    documentsEmpty: 'Aún no hay documentos.',
    documentsError: 'No se pudieron cargar los documentos.',
  },
  supplierProducts: {
    title: 'Condiciones de compra',
    subtitle: 'Artículos, SKUs del proveedor, precios de compra y plazos de entrega.',
    add: 'Vincular artículo',
    createTitle: 'Agregar condición de compra',
    editTitle: 'Editar condición de compra',
    description: 'Las condiciones se aplican a este proveedor y al artículo seleccionado.',
    product: 'Artículo',
    productHint: 'Buscar por número de artículo o nombre.',
    productPlaceholder: 'Buscar artículos …',
    noProducts: 'No se encontraron artículos.',
    supplierSku: 'SKU del proveedor',
    purchasePrice: 'Precio de compra (neto)',
    packagingUnit: 'Unidad de embalaje',
    packagingFactor: 'Unidades base por unidad de embalaje',
    leadTimeDays: 'Tiempo de entrega (días)',
    minOrderQuantity: 'Cantidad mínima de pedido',
    isPreferredSupplier: 'Proveedor preferido para este artículo',
    preferred: 'Preferido',
    notes: 'Nota',
    empty: 'Aún no hay condiciones de compra.',
    saved: 'Condición de compra guardada.',
    saveError: 'No se pudo guardar la condición de compra.',
    loadError: 'No se pudieron cargar las condiciones de compra.',
    edit: 'Editar condición de compra',
    delete: 'Eliminar condición de compra',
    deleted: 'Condición de compra eliminada.',
    deleteTitle: 'Eliminar condición de compra',
    deleteDescription: 'Se eliminarán las condiciones para "{{name}}".',
    columns: {
      article: 'Artículo',
      supplierSku: 'SKU del proveedor',
      purchasePrice: 'Precio de compra',
      packaging: 'Empaque',
      leadTimeDays: 'Plazo de entrega',
      minOrderQuantity: 'Cantidad mínima',
      preferred: 'Preferido',
    },
  },
  supplierOrders: {
    purchaseOrder: 'Orden de compra',
    itemCount_one: 'Línea {{count}}',
    itemCount_other: 'Líneas {{count}}',
    deliveryDate: 'Recepción de mercancías {{date}}',
    empty: 'Aún no hay órdenes de compra para este proveedor.',
    loadError: 'No se pudieron cargar las órdenes de compra.',
  },
  addresses: {
    title: 'Direcciones alternativas',
    add: 'Dirección',
    isDefault: 'Predeterminado',
    empty: 'No hay direcciones alternativas almacenadas.',
    deleted: 'Dirección eliminada.',
    delete: 'Eliminar dirección',
    deleteTitle: 'Eliminar dirección',
    deleteDescription: 'La dirección será eliminada del registro del socio.',
    loadError: 'No se pudieron cargar las direcciones.',
    types: {
      BILLING: 'Dirección de facturación',
      SHIPPING: 'Dirección de envío',
      OTHER: 'Otros',
    },
  },
  contacts: {
    title: 'Contactos',
    add: 'Contacto',
    isPrimary: 'Contacto principal',
    empty: 'No hay contactos almacenados.',
    deleted: 'Contacto eliminado.',
    delete: 'Eliminar contacto',
    deleteTitle: 'Eliminar contacto',
    deleteDescription: 'El contacto será eliminado del registro del socio.',
    loadError: 'No se pudieron cargar los contactos.',
  },
  customFields: {
    title: 'Campos personalizados dinámicos',
    subtitle: 'Solo se muestran los campos que coinciden con los roles de este socio.',
    empty: 'No se han definido campos personalizados para los roles de este socio.',
    saved: 'Campos personalizados guardados.',
  },
};
